/* eslint-disable no-unused-vars */
import { Palette } from 'config';
import styled from 'styled-components';

export const Slice = styled.div`
  position: fixed;
  width: 100vw;
  height: 100vh;
  top: 0;
  left: 0;
  opacity: 0;
  z-index: 999;
`;

export const Container = styled.div`
  width: ${({ width }) => (width ? `${width}px` : '100%')};
  display: flex;
  position: relative;
  flex-direction: column;
  z-index: ${({ isOpen }) => {
    return isOpen ? '1000' : 'unset';
  }};
`;

export const Ul = styled.ul`
  max-height: ${({ maxHeight }) => `${maxHeight - 12}px`};
  overflow: auto;
  padding: 0;
  ::-webkit-scrollbar {
    width: 6px;
    background-color: #ffffff;
  }
  ::-webkit-scrollbar-thumb {
    border-radius: 10px;
    background-color: ${() => Palette.PrimaryGray._300};
  }
  ::-webkit-scrollbar-track {
    border-radius: 10px;
    background-color: #ffffff;
  }
  li {
    display: inline-flex;
    align-items: center;
    width: 100%;
    list-style: none;
    cursor: pointer;
    user-select: none;
    border-radius: 4px;
    white-space: nowrap;
    text-wrap: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    padding: 7px 10px;
    font-weight: 400;
    font-size: 14px;
    line-height: 24px;
    &:hover {
      background: ${() => Palette.PrimaryGray._100};
      color: ${() => Palette.Primary._500};
    }
    &:active {
      background: ${() => Palette.Primary._000};
    }
  }
  li.active {
    background: ${() => Palette.PrimaryGray._100};
    color: ${() => Palette.Primary._500};
    border: ${() => '1px solid' + `${Palette.Primary._300}`};
  }
  li * {
    text-overflow: ellipsis;
    white-space: nowrap;
    text-wrap: nowrap;
    overflow: hidden;
  }
`;

export const InputContainer = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  .MuiInputBase-root {
    //background: white;
  }
  input {
    padding-left: ${({ isSearchIcon, isIcon }) =>
      isSearchIcon && isIcon
        ? '48px !important'
        : isSearchIcon || isIcon
        ? '28px !important'
        : '8px !important'};
    //cursor: pointer;
  }
  input:placeholder-shown {
    text-overflow: ellipsis;
  }
`;

export const SelectedItem = styled.div`
  position: absolute;
  top: 0;
  left: ${({ isIcon }) => (isIcon ? '32px' : '10px')};
  right: 0;
  bottom: 0;
  list-style: none;
  width: ${({ isIcon }) => (isIcon ? 'calc(100% - 78px)' : 'calc(100% - 58px)')};
  padding: 8px;
  user-select: none;
  pointer-events: none;
  cursor: pointer;
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-wrap: nowrap;

  * {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    text-wrap: nowrap;
  }
`;

export const SearchIcon = styled.div`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: 12px;
  right: 0;
  bottom: 0;
  width: 16px;
  height: 16px;
  user-select: none;
  pointer-events: none;

  svg {
    width: 100%;
    height: 100%;
    fill: ${Palette.PrimaryGray._400};
  }
`;

export const Icon = styled.div`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: ${({ isSearchIcon }) => (isSearchIcon ? '34px' : '12px')};
  right: 0;
  bottom: 0;
  width: 16px;
  height: 16px;
  user-select: none;
  pointer-events: none;

  svg {
    width: 100%;
    height: 100%;
    fill: ${Palette.PrimaryGray._400};
  }
`;

export const ComponentForScroll = styled.div`
  z-index: 1000;
  background: white;
  max-height: 270px;
  padding: 8px;
  box-shadow: 0px 16px 24px rgba(23, 43, 77, 0.04), 0px 16px 32px rgba(23, 43, 77, 0.08);
  border-radius: 4px;
  border: 1px solid ${Palette.PrimaryGray._200};
`;
